appHost.actions.register({
    // #region Vars
    name: '288a.entity.edit',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Nummer
        let tID = this.getID(params, data);
        // #endregion
        // #region Entity
        let tEntity = { domain: 'erp', segments: [] };
        {
            if (params.entity) {
                tEntity = { ...params.entity };
            }
            if (params.domainName) {
                tEntity.domain = params.domainName;
            }
            if (params.namespace) {
                tEntity.namespace = params.namespace;
            }
            if (params.entityName) {
                tEntity.segments = [
                    {
                        name: params.entityName,
                        id: tID
                    }
                ];
            }
            if (params.fieldName) {
                tEntity.segments.push({
                    name: params.fieldName,
                    id: tID
                });
            }
            Object.keys(params).forEach(e => {
                if (e.startsWith("entityField_")) {
                    tEntity.segments.push({
                        name: params[e],
                        id: this.getIdForSegment(params, data, e.substring("entityField_".length)),
                    });
                }
            });
        }
        // #endregion
        // #region Args
        let tArgs = {
            entity: tEntity,
            owner: undefined,
            viewName: params?.viewName,
            mode: params?.mode,
            args: {
                data: data,
                ...params,
            }
        };
        // #endregion
        // #region Instance
        if (data && data.__g_isproxy) {
            tArgs.owner = data;
        }
        // #endregion
        // #region Debug
        utils.logDebug("action: 288a.entity.edit", {
            data: data,
            params: params,
            args: tArgs,
        });
        // #endregion        
        // #region Url
        if (params.url && false) {
            //Show
            this.$appHost.router.openWindow((tArgs.viewName ?? 'details') + '(\'' + tID + '\')');
            //Return
            return this.Ok();
        }
        // #endregion
        // #region Popup
        else {
            let tWindow = {
                variant: params?.w ?? 'popup',
                position: params.l,
                size: params.s ?? 'xlarge',
            };
            if (!this.$appHost.notification.hasOpenWindows()) {
                tWindow.variant = params?.w ?? "slide";
                tWindow.position = params.l ?? "bottom";
                tWindow.size = params.s ?? "large";
            }
            //Show
            let tResult = await this.$appHost.notification.showModal2('g-layout__layout-entity', tArgs, tWindow);
            {
                if (tResult.state !== 1) {
                    return this.Cancel();
                }
            }
            //Finish
            return this.Ok();
        }
        // #endregion
    },
    // #endregion
    // #region Methods
    methods: {
        getID(params, data) {
            if (params.nummer) {
                return params.nummer;
            }
            else if (params.id) {
                return params.id;
            }
            else if (params.keyFieldNames) {
                let tKeys = params.keyFieldNames.split(',');
                let tID = null;
                if (tKeys.length == 0) {
                    tID = null;
                }
                else if (tKeys.length == 1) {
                    tID = this.$utils.evalParams('{' + tKeys[0] + '}', data);
                }
                else {
                    let tKey = {};
                    {
                        tKeys.forEach(k => {
                            tKey[k] = this.$utils.evalParams('{' + k + '}', data);
                        });
                    }
                    tID = "j_" + utils.encodeBase64(JSON.stringify(tKey));
                }
                return tID;
            }
            else {
                return null;
            }
        },
        getIdForSegment(params, data, segment) {
            if (params['entityId_' + segment]) {
                return params['entityId_' + segment];
            }
            else if (params['entityKeyFields_' + segment]) {
                let tKeys = params['entityKeyFields_' + segment].split(',');
                let tID = null;
                if (tKeys.length == 0) {
                    tID = null;
                }
                else if (tKeys.length == 1) {
                    tID = this.$utils.evalParams('{' + tKeys[0] + '}', data);
                }
                else {
                    let tKey = {};
                    {
                        tKeys.forEach(k => {
                            tKey[k] = this.$utils.evalParams('{' + k + '}', data);
                        });
                    }
                    tID = "j_" + utils.encodeBase64(JSON.stringify(tKey));
                }
                return tID;
            }
            else {
                return null;
            }
        }
    }
    // #endregion
});
export {};
